import cookie from "js-cookie";
import nextSignleton from "../utils/nextSignleton";

const updateExpires = options => {
	const { expires } = options || {};
	if (typeof expires !== "number") return options;
	return {
		...options,
		expires: new Date(Date.now() + expires * 24 * 60 * 60 * 1e3),
	};
};

const serverCookie = ({ req, res }, cache) => ({
	read: cookieName => {
		if (cache.has(cookieName)) return cache.get(cookieName);
		const value = req.cookies[cookieName];
		cache.set(cookieName, value);
		return value;
	},
	write: (cookieName, value, options) => {
		if (value == null) return;
		cache.set(cookieName, value);
		res.cookie(cookieName, value, updateExpires(options));
	},
	remove: cookieName => {
		cache.delete(cookieName);
		res.cookie(cookieName, "", { expires: new Date() });
	},
});

const clientCookie = () => ({
	read: cookieName => cookie.get()[cookieName],
	write: (cookieName, value, options) => {
		cookie.set(cookieName, value, options);
	},
	remove: cookieName => {
		cookie.remove(cookieName);
	},
});

const Cookies = nextSignleton(
	globalContext =>
		global.window != null
			? clientCookie() // using client Cookies in browser
			: serverCookie(globalContext, new Map()), // using serverside cookies
);

export default Cookies;
